import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "table-row-menu__option--text" }

import SvgLoader from '@/utils/SvgLoader.vue';
import { computed, ref, StyleValue } from 'vue';
import { getRandomStr } from '@/businessRepository/idUtils';
import { BUSINESS_ROW_MENU_ITEMS } from '../../constants/';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'BusinessRowMenu',
  props: {
    isOrderMode: { type: Boolean },
    disabled: { type: Boolean },
    toolTipMessage: {}
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

/** Emits */
const emits = __emit;

/** Variables */
const t = i18n.t;
const containerId = getRandomStr(16);
const isMenuOpenedState = ref<boolean>(false);
const businessRowMenuButtonPosition = ref({
  x: 0,
  y: 0,
});

/** Function */
/**
 * ボタンクリック時orモーダル外をクリックした際の処理
 */
const onClickButton = () => {
  if (!isMenuOpenedState.value) {
    const buttonContent = document.getElementById(containerId);
    const bodyContent = document.getElementsByTagName('body')[0];
    if (!(buttonContent instanceof HTMLElement) || !(bodyContent instanceof HTMLElement)) return;
    businessRowMenuButtonPosition.value = {
      x: buttonContent.offsetWidth,
      y: buttonContent.getBoundingClientRect().top,
    };
  }
  isMenuOpenedState.value = !isMenuOpenedState.value;
};

const tableHeaderModifyMenuStyle = computed((): StyleValue => {
  return {
    top: `${businessRowMenuButtonPosition.value.y + 20}px`,
    right: `${businessRowMenuButtonPosition.value.x}px`,
  };
});
/**
 * 選択肢を選んだ際の処理
 * @param value - 選択した値
 */
const selectOption = (value: (typeof BUSINESS_ROW_MENU_ITEMS)[number]['value']) => {
  isMenuOpenedState.value = false;
  emits('select', value);
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      id: _unref(containerId),
      class: _normalizeClass(["table-row-menu__button__container", { 'not-allow-cursor': _ctx.disabled }])
    }, [
      _createElementVNode("button", {
        class: _normalizeClass(["table-row-menu__button", { 'table-row-menu__button--active': isMenuOpenedState.value, 'disabled-event': _ctx.disabled }]),
        onClick: onClickButton
      }, [
        _createVNode(SvgLoader, {
          class: "table-row-menu__icon",
          name: "menuEllipsis"
        })
      ], 2)
    ], 10, _hoisted_1)), [
      [
        _directive_tooltip,
        _ctx.toolTipMessage,
        void 0,
        { bottom: true }
      ]
    ]),
    (isMenuOpenedState.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", {
            class: "table-row-menu__bg",
            onClick: onClickButton
          }),
          _createElementVNode("div", {
            class: "table-row-menu__dropdown",
            style: _normalizeStyle(tableHeaderModifyMenuStyle.value)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BUSINESS_ROW_MENU_ITEMS), (option) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                key: option.value,
                class: _normalizeClass(["table-row-menu__content", _ctx.isOrderMode && option.value === 'editTransaction' && 'not-allow-cursor'])
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(
            _ctx.isOrderMode && option.value === 'editTransaction'
              ? 'table-row-menu__option table-row-menu__option--disabled disabled-event'
              : 'table-row-menu__option table-row-menu__option--active'
          ),
                  onClick: ($event: any) => (selectOption(option.value))
                }, [
                  _createVNode(SvgLoader, {
                    class: "table-row-menu__icon",
                    name: option.icon
                  }, null, 8, ["name"]),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)(option.text)), 1)
                ], 10, _hoisted_2)
              ], 2)), [
                [
                  _directive_tooltip,
                  _ctx.isOrderMode && option.value === 'editTransaction' && _unref(t)('発注表示時は使用できません'),
                  void 0,
                  { bottom: true }
                ]
              ])
            }), 128))
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})